import React from 'react';
import '../../icons/style.css';
import { MirrorContainer, StyledIcon } from './styles';
import { IconName } from './types';

export interface IconProps extends React.HTMLAttributes<HTMLElement> {
  name: IconName;
  variant?: 'outlined' | 'standart' | 'filled';
  className?: string;
  size?: number;
  mirrored?: boolean;
}

const Icon: React.FC<IconProps> = ({
  name,
  className,
  size,
  color,
  variant = 'standart',
  mirrored,
  onClick,
  ...props
}) => {
  if (mirrored) {
    return (
      <MirrorContainer>
        <StyledIcon
          variant={variant}
          className={`icon-${name} ${className || ''}`}
          style={{
            color,
            ...(size && { fontSize: size }),
            ...(!!onClick && { cursor: 'pointer' }),
          }}
          onClick={onClick}
          {...props}
        />
      </MirrorContainer>
    );
  }

  return (
    <StyledIcon
      variant={variant}
      className={`icon-${name} ${className || ''}`}
      color={color}
      style={{
        color,
        ...(size && { fontSize: size }),
        ...(!!onClick && { cursor: 'pointer' }),
      }}
      onClick={onClick}
      {...props}
    />
  );
};

export default Icon;
